export enum ToastPosition {
  BOTTOM = 'bottom',
  MIDDLE = 'middle',
  DEFAULT = 'top',
}

export enum ToastDuration {
  DEFAULT_MS = 1000,
}
